exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer[data-v-7b12da5e]{background:#e8e1ce;padding:30px 0;text-align:center;color:#000;margin-top:20px}#dissenyador[data-v-7b12da5e]{margin-top:20px;font-size:13px}a[data-v-7b12da5e]{color:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7b12da5e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/Footer.vue
// module id = 256
// module chunks = 0